import { PILLARS } from "../../lib/site";
import SectionHeader from "../SectionHeader";

export default function Framework() {
  return (
    <section
      data-testid="framework-section"
      id="framework"
      className="bg-white relative"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-12 py-20 md:py-28">
        <SectionHeader
          eyebrow="The Solution"
          accent="#0055FF"
          title={
            <>
              Introducing the{" "}
              <span className="bg-[#FFD700] px-2 inline-block">
                TinkerShift
              </span>{" "}
              Framework.
            </>
          }
          intro="A practical framework for designing learning environments where students create, build, test, share and adapt."
          testid="framework-header"
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-7">
          {PILLARS.map((p, i) => (
            <div
              key={p.title}
              data-testid={`framework-pillar-${p.title.toLowerCase()}`}
              style={{
                backgroundColor: p.color,
                color: p.text,
                transform: `rotate(${[-1.5, 1.5, -1, 1.2, -0.8][i]}deg)`,
              }}
              className={`rounded-3xl nb-border-thick nb-shadow p-6 md:p-7 nb-lift relative overflow-hidden ${
                i === 2 ? "lg:translate-y-6" : ""
              } ${i === 4 ? "lg:-translate-y-3" : ""}`}
            >
              <div className="flex items-baseline justify-between">
                <span className="font-mono text-xs uppercase tracking-widest opacity-80">
                  Pillar 0{i + 1}
                </span>
                <span className="font-display font-black text-5xl leading-none opacity-90">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <p className="mt-6 font-display font-black text-3xl md:text-4xl leading-none tracking-tighter">
                {p.title}.
              </p>
              <p className="mt-4 text-sm md:text-base font-semibold leading-relaxed">
                {p.blurb}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
